(() => {
  'use strict';

  const GALLERY_SELECTOR =
    'quick-add-modal media-gallery';

  const SWIPE_THRESHOLD = 35;
  const ANIMATION_DURATION = 350;

  class LilMiracleQuickAddGallery {
    constructor(gallery) {
      this.gallery = gallery;

      this.track = gallery.querySelector(
        '.product__media-list'
      );

      this.slides = this.track
        ? Array.from(
            this.track.querySelectorAll(
              ':scope > .product__media-item'
            )
          )
        : [];

      this.logicalIndex = 0;

      this.isDragging = false;
      this.isAnimating = false;
      this.hasMoved = false;

        this.startX = 0;
        this.startY = 0;
        this.currentX = 0;
        this.currentY = 0;

        /*
        * Pointer-Bewegungen werden nicht mehr bei jedem
        * einzelnen Browser-Event direkt gerendert.
        *
        * requestAnimationFrame bündelt die Bewegung auf
        * einen DOM-Schreibvorgang pro Bildschirmframe.
        */
        this.animationFrameId = null;
        this.pendingDifference = 0;

        this.previousClone = null;
        this.previousPrepared = false;

      this.pagination = null;
      this.paginationTrack = null;
      this.paginationDots = [];
      this.paginationTimeout = null;

      if (!this.track || this.slides.length === 0) {
        return;
      }

      this.handlePointerDown =
        this.handlePointerDown.bind(this);

      this.handlePointerMove =
        this.handlePointerMove.bind(this);

      this.handlePointerUp =
        this.handlePointerUp.bind(this);

      this.handleClick =
        this.handleClick.bind(this);

        this.prepareGallery();
        this.createPagination();
        this.bindEvents();
        this.updateSlideClasses();
        this.updatePagination();
        this.preloadVisibleMedia();
    }

    prepareGallery() {
      this.gallery.classList.add(
        'lm-quick-add-gallery'
      );

      this.track.classList.add(
        'lm-quick-add-gallery__track'
      );

      this.track.style.transition = 'none';
      this.track.style.transform =
        'translate3d(0, 0, 0)';

      this.slides.forEach((slide, index) => {
        slide.classList.add(
          'lm-quick-add-gallery__slide'
        );

        slide.dataset.lmOriginalIndex =
          String(index);

        slide.setAttribute(
          'aria-label',
          `${index + 1} / ${this.slides.length}`
        );
      });

      /*
       * Die von Shopify mitgelieferten Galerie-Steuerelemente
       * werden im Quick Add nicht benötigt.
       */
      this.gallery
        .querySelectorAll(
          [
            '.slider-buttons',
            '.thumbnail-slider',
            '.product__media-list + .slider-buttons'
          ].join(',')
        )
        .forEach((element) => {
          element.classList.add(
            'lm-quick-add-gallery__shopify-control'
          );
        });
    }

    createPagination() {
      if (this.slides.length <= 1) {
        return;
      }

      this.pagination =
        document.createElement('div');

      this.pagination.className =
        'lm-quick-add-gallery__pagination';

      this.pagination.setAttribute(
        'aria-label',
        'Produktmedien'
      );

      this.paginationTrack =
        document.createElement('div');

      this.paginationTrack.className =
        'lm-quick-add-gallery__pagination-track';

      this.pagination.appendChild(
        this.paginationTrack
      );

      this.track.insertAdjacentElement(
        'afterend',
        this.pagination
      );

      /*
       * Bis fünf Medien:
       * Ein normaler Punkt pro Medium.
       *
       * Mehr als fünf Medien:
       * Sieben Punkte, davon fünf sichtbar und
       * jeweils ein Reservepunkt links und rechts.
       */
      const dotCount =
        this.slides.length <= 5
          ? this.slides.length
          : 7;

      for (
        let index = 0;
        index < dotCount;
        index += 1
      ) {
        const dot =
          document.createElement('button');

        dot.type = 'button';

        dot.className =
          'lm-quick-add-gallery__dot';

        dot.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            event.stopPropagation();

            if (this.isAnimating) {
              return;
            }

            if (this.slides.length <= 5) {
              const targetIndex =
                Number(
                  dot.dataset.slideTarget
                );

              if (
                Number.isNaN(targetIndex)
              ) {
                return;
              }

              this.moveToIndex(targetIndex);
              return;
            }

            const currentDots =
              Array.from(
                this.paginationTrack.children
              );

            const visualPosition =
              currentDots.indexOf(dot);

            const relativePosition =
              visualPosition - 3;

            if (
              relativePosition < -2 ||
              relativePosition > 2 ||
              relativePosition === 0
            ) {
              return;
            }

            this.moveBy(relativePosition);
          }
        );

        this.paginationTrack.appendChild(dot);
        this.paginationDots.push(dot);
      }
    }

    bindEvents() {
      if (this.slides.length <= 1) {
        return;
      }

      this.gallery.addEventListener(
        'pointerdown',
        this.handlePointerDown
      );

      this.gallery.addEventListener(
        'pointermove',
        this.handlePointerMove
      );

      this.gallery.addEventListener(
        'pointerup',
        this.handlePointerUp
      );

      this.gallery.addEventListener(
        'pointercancel',
        this.handlePointerUp
      );

      this.gallery.addEventListener(
        'click',
        this.handleClick,
        true
      );
    }

    handlePointerDown(event) {
    if (
        this.isAnimating ||
        event.target.closest(
        '.lm-quick-add-gallery__dot'
        )
    ) {
        return;
    }

    if (
        event.button !== undefined &&
        event.button !== 0
    ) {
        return;
    }

    this.isDragging = true;
    this.hasMoved = false;

    this.startX = event.clientX;
    this.startY = event.clientY;

    this.currentX = event.clientX;
    this.currentY = event.clientY;

    this.pendingDifference = 0;

    this.track.style.transition = 'none';

    if (this.gallery.setPointerCapture) {
        try {
        this.gallery.setPointerCapture(
            event.pointerId
        );
        } catch (error) {
        /*
        * Pointer Capture ist je nach Browser und
        * Eingabegerät nicht immer verfügbar.
        */
        }
    }
    }

    handlePointerMove(event) {
    if (
        !this.isDragging ||
        this.isAnimating
    ) {
        return;
    }

    this.currentX = event.clientX;
    this.currentY = event.clientY;

    const differenceX =
        this.currentX - this.startX;

    const differenceY =
        this.currentY - this.startY;

    /*
    * Sobald eine erkennbare horizontale Bewegung
    * beginnt, darf daraus kein Klick auf ein Bild
    * oder einen Video-Play-Button mehr entstehen.
    */
    if (Math.abs(differenceX) > 5) {
        this.hasMoved = true;
    }

    /*
    * Browser-Scrolling und Gummibandbewegungen
    * innerhalb der Galerie unterdrücken.
    */
    if (
        Math.abs(differenceX) >
        Math.abs(differenceY) ||
        this.hasMoved
    ) {
        event.preventDefault();
    }

    this.pendingDifference =
        differenceX;

    /*
    * Bereits geplanten Frame weiterverwenden.
    * Dadurch gibt es höchstens einen Transform-
    * Schreibvorgang pro Bildschirmframe.
    */
    if (this.animationFrameId !== null) {
        return;
    }

    this.animationFrameId =
        window.requestAnimationFrame(() => {
        this.animationFrameId = null;

        const difference =
            this.pendingDifference;

        if (difference > 0) {
            this.preparePreviousSlide();

            this.track.style.transform =
            `translate3d(calc(-100% + ${difference}px), 0, 0)`;

            return;
        }

        if (this.previousPrepared) {
            this.cancelPreviousPreparation();
        }

        this.track.style.transform =
            `translate3d(${difference}px, 0, 0)`;
        });
    }

    handlePointerUp(event) {
    if (!this.isDragging) {
        return;
    }

    this.isDragging = false;

    if (this.animationFrameId !== null) {
        window.cancelAnimationFrame(
        this.animationFrameId
        );

        this.animationFrameId = null;
    }

    const difference =
        this.currentX - this.startX;

    /*
    * Den letzten Pointer-Wert noch einmal unmittelbar
    * übernehmen, bevor die Abschlussanimation startet.
    */
    this.pendingDifference =
        difference;

    if (
        difference <= -SWIPE_THRESHOLD
    ) {
        this.slideNext();
    } else if (
        difference >= SWIPE_THRESHOLD
    ) {
        this.slidePrevious();
    } else {
        this.resetPosition();
    }

    if (
        this.gallery.hasPointerCapture &&
        this.gallery.hasPointerCapture(
        event.pointerId
        )
    ) {
        try {
        this.gallery.releasePointerCapture(
            event.pointerId
        );
        } catch (error) {
        /*
        * Der Pointer wurde gegebenenfalls bereits
        * automatisch vom Browser freigegeben.
        */
        }
    }

    window.setTimeout(() => {
        this.hasMoved = false;
    }, 100);
    }

    handleClick(event) {
      if (!this.hasMoved) {
        return;
      }

      /*
       * Nach einem Swipe darf weder ein Bildmodal
       * noch ein Video versehentlich geöffnet werden.
       */
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }

    preparePreviousSlide() {
      if (
        this.previousPrepared ||
        this.isAnimating
      ) {
        return;
      }

      const lastRealSlide =
        this.track.lastElementChild;

      if (!lastRealSlide) {
        return;
      }

      this.previousClone =
        lastRealSlide.cloneNode(true);

      this.previousClone.classList.add(
        'lm-quick-add-gallery__temporary-clone'
      );

      this.previousClone.removeAttribute('id');

      this.previousClone.setAttribute(
        'aria-hidden',
        'true'
      );

      /*
       * Doppelte IDs innerhalb des Klons vermeiden.
       */
      this.previousClone
        .querySelectorAll('[id]')
        .forEach((element) => {
          element.removeAttribute('id');
        });

      /*
       * Videos innerhalb des temporären Klons dürfen
       * nicht gestartet werden.
       */
      this.previousClone
        .querySelectorAll(
          'button, a, input, video, deferred-media'
        )
        .forEach((element) => {
          element.setAttribute(
            'tabindex',
            '-1'
          );

          element.setAttribute(
            'aria-hidden',
            'true'
          );
        });

      this.track.insertBefore(
        this.previousClone,
        this.track.firstElementChild
      );

      this.track.style.transition = 'none';
      this.track.style.transform =
        'translate3d(-100%, 0, 0)';

      void this.track.offsetWidth;

      this.previousPrepared = true;
    }

    cancelPreviousPreparation() {
      if (!this.previousPrepared) {
        return;
      }

      if (
        this.previousClone &&
        this.previousClone.parentNode ===
          this.track
      ) {
        this.previousClone.remove();
      }

      this.previousClone = null;
      this.previousPrepared = false;

      this.track.style.transition = 'none';
      this.track.style.transform =
        'translate3d(0, 0, 0)';

      void this.track.offsetWidth;
    }

    resetPosition() {
      if (this.previousPrepared) {
        this.track.style.transition =
          `transform ${ANIMATION_DURATION}ms ease`;

        this.track.style.transform =
          'translate3d(-100%, 0, 0)';

        window.setTimeout(() => {
          this.cancelPreviousPreparation();
        }, ANIMATION_DURATION);

        return;
      }

      this.track.style.transition =
        `transform ${ANIMATION_DURATION}ms ease`;

      this.track.style.transform =
        'translate3d(0, 0, 0)';
    }

    slideNext() {
      if (this.isAnimating) {
        return;
      }

      if (this.previousPrepared) {
        this.cancelPreviousPreparation();
      }

      this.isAnimating = true;

      this.startPaginationAnimation(1);

      this.track.style.transition =
        `transform ${ANIMATION_DURATION}ms ease`;

      this.track.style.transform =
        'translate3d(-100%, 0, 0)';

      window.setTimeout(() => {
        const firstSlide =
          this.track.firstElementChild;

        if (firstSlide) {
          this.track.appendChild(
            firstSlide
          );
        }

        this.logicalIndex =
          this.modulo(
            this.logicalIndex + 1,
            this.slides.length
          );

        this.track.style.transition =
          'none';

        this.track.style.transform =
          'translate3d(0, 0, 0)';

        this.pauseInactiveVideos();
        this.updateSlideClasses();
        this.finishPaginationAnimation(1);
        this.preloadVisibleMedia();

        void this.track.offsetWidth;

        requestAnimationFrame(() => {
          this.isAnimating = false;
        });
      }, ANIMATION_DURATION);
    }

    slidePrevious() {
      if (this.isAnimating) {
        return;
      }

      if (!this.previousPrepared) {
        this.preparePreviousSlide();
      }

      if (!this.previousPrepared) {
        return;
      }

      this.isAnimating = true;

      this.startPaginationAnimation(-1);

      this.track.style.transition =
        `transform ${ANIMATION_DURATION}ms ease`;

      this.track.style.transform =
        'translate3d(0, 0, 0)';

      window.setTimeout(() => {
        const lastRealSlide =
          this.track.lastElementChild;

        if (
          this.previousClone &&
          this.previousClone.parentNode ===
            this.track
        ) {
          this.previousClone.remove();
        }

        if (lastRealSlide) {
          this.track.insertBefore(
            lastRealSlide,
            this.track.firstElementChild
          );
        }

        this.previousClone = null;
        this.previousPrepared = false;

        this.logicalIndex =
          this.modulo(
            this.logicalIndex - 1,
            this.slides.length
          );

        this.track.style.transition =
          'none';

        this.track.style.transform =
          'translate3d(0, 0, 0)';

        this.pauseInactiveVideos();
        this.updateSlideClasses();
        this.finishPaginationAnimation(-1);
        this.preloadVisibleMedia();

        void this.track.offsetWidth;

        requestAnimationFrame(() => {
          this.isAnimating = false;
        });
      }, ANIMATION_DURATION);
    }

    moveBy(relativePosition) {
      if (
        this.isAnimating ||
        relativePosition === 0
      ) {
        return;
      }

      const direction =
        relativePosition > 0 ? 1 : -1;

      const steps =
        Math.abs(relativePosition);

      this.runMultipleSteps(
        direction,
        steps
      );
    }

    runMultipleSteps(
      direction,
      remainingSteps
    ) {
      if (remainingSteps <= 0) {
        return;
      }

      if (direction > 0) {
        this.slideNext();
      } else {
        this.slidePrevious();
      }

      if (remainingSteps > 1) {
        window.setTimeout(() => {
          this.runMultipleSteps(
            direction,
            remainingSteps - 1
          );
        }, ANIMATION_DURATION + 40);
      }
    }

    moveToIndex(targetIndex) {
      const normalizedTarget =
        this.modulo(
          targetIndex,
          this.slides.length
        );

      const forwardDistance =
        this.modulo(
          normalizedTarget -
            this.logicalIndex,
          this.slides.length
        );

      const backwardDistance =
        this.modulo(
          this.logicalIndex -
            normalizedTarget,
          this.slides.length
        );

      if (
        forwardDistance === 0 &&
        backwardDistance === 0
      ) {
        return;
      }

      if (
        forwardDistance <=
        backwardDistance
      ) {
        this.runMultipleSteps(
          1,
          forwardDistance
        );
      } else {
        this.runMultipleSteps(
          -1,
          backwardDistance
        );
      }
    }

    preloadVisibleMedia() {
    const currentSlides =
        Array.from(
        this.track.children
        ).filter((slide) => {
        return !slide.classList.contains(
            'lm-quick-add-gallery__temporary-clone'
        );
        });

    if (currentSlides.length === 0) {
        return;
    }

    /*
    * Durch die DOM-Umsortierung ist:
    *
    * Position 0 = aktuelles Medium
    * Position 1 = nächstes Medium
    * Position 2 = übernächstes Medium
    * letzte Position = vorheriges Medium
    */
    const slidesToPreload = [
        currentSlides[0],
        currentSlides[1],
        currentSlides[2],
        currentSlides[
        currentSlides.length - 1
        ]
    ].filter(Boolean);

    slidesToPreload.forEach(
        (slide, index) => {
        this.preloadSlide(
            slide,
            index === 0
        );
        }
    );

    /*
    * Das Video der direkt nächsten Slide bereits
    * mit niedriger Priorität im Browser vormerken.
    */
    if (currentSlides[1]) {
        this.prefetchVideo(
        currentSlides[1]
        );
    }
    }

    preloadSlide(slide, isCurrent) {
    slide
        .querySelectorAll('img')
        .forEach((image) => {
        image.loading = 'eager';
        image.decoding = 'async';

        try {
            image.fetchPriority =
            isCurrent ? 'high' : 'auto';
        } catch (error) {
            /*
            * fetchPriority wird von älteren Browsern
            * möglicherweise nicht unterstützt.
            */
        }

        /*
        * decode() sorgt dafür, dass das Bild möglichst
        * schon vor dem sichtbaren Wechsel dekodiert ist.
        */
        if (
            typeof image.decode ===
            'function' &&
            image.complete
        ) {
            image.decode().catch(() => {
            /*
            * Ein Decode-Fehler beeinträchtigt das
            * normale Laden des Bildes nicht.
            */
            });
        }
        });

    /*
    * Wird das Video später durch Shopifys
    * deferred-media aktiviert, soll es nicht mehr
    * mit preload="none" starten.
    */
    slide
        .querySelectorAll('template')
        .forEach((template) => {
        const templateVideo =
            template.content
            ?.querySelector('video');

        if (templateVideo) {
            templateVideo.preload =
            isCurrent
                ? 'auto'
                : 'metadata';
        }
        });

    slide
        .querySelectorAll('video')
        .forEach((video) => {
        video.preload =
            isCurrent
            ? 'auto'
            : 'metadata';
        });
    }

    prefetchVideo(slide) {
    if (
        slide.dataset.lmVideoPrefetched ===
        'true'
    ) {
        return;
    }

    const template =
        slide.querySelector('template');

    const source =
        template?.content
        ?.querySelector('video source');

    const sourceUrl =
        source?.getAttribute('src');

    if (!sourceUrl) {
        return;
    }

    const existingPrefetch =
        document.head.querySelector(
        `link[data-lm-video-prefetch="${CSS.escape(
            sourceUrl
        )}"]`
        );

    if (existingPrefetch) {
        slide.dataset.lmVideoPrefetched =
        'true';

        return;
    }

    const prefetchLink =
        document.createElement('link');

    prefetchLink.rel = 'prefetch';
    prefetchLink.as = 'video';
    prefetchLink.href = sourceUrl;

    prefetchLink.dataset.lmVideoPrefetch =
        sourceUrl;

    document.head.appendChild(
        prefetchLink
    );

    slide.dataset.lmVideoPrefetched =
        'true';
    }


    pauseInactiveVideos() {
      const currentSlides =
        Array.from(
          this.track.children
        ).filter((slide) => {
          return !slide.classList.contains(
            'lm-quick-add-gallery__temporary-clone'
          );
        });

      currentSlides.forEach(
        (slide, index) => {
          if (index === 0) {
            return;
          }

          slide
            .querySelectorAll('video')
            .forEach((video) => {
              try {
                video.pause();
              } catch (error) {
                /*
                 * Manche eingebetteten Medien lassen
                 * sich nicht programmatisch pausieren.
                 */
              }
            });
        }
      );
    }

    updateSlideClasses() {
      const currentSlides =
        Array.from(
          this.track.children
        ).filter((slide) => {
          return !slide.classList.contains(
            'lm-quick-add-gallery__temporary-clone'
          );
        });

      currentSlides.forEach(
        (slide, index) => {
          const isActive = index === 0;

          slide.classList.toggle(
            'is-active',
            isActive
          );

          slide.classList.toggle(
            'lm-quick-add-gallery__slide--active',
            isActive
          );

          slide.setAttribute(
            'aria-hidden',
            isActive ? 'false' : 'true'
          );
        }
      );
    }

    applyPaginationDotClass(
      dot,
      visualPosition
    ) {
      dot.classList.remove(
        'lm-dot-hidden-prev',
        'lm-dot-far-prev',
        'lm-dot-prev',
        'lm-dot-active',
        'lm-dot-next',
        'lm-dot-far-next',
        'lm-dot-hidden-next',
        'is-active'
      );

      if (
        this.slides.length <= 5
      ) {
        return;
      }

      if (visualPosition === 0) {
        dot.classList.add(
          'lm-dot-hidden-prev'
        );
      } else if (
        visualPosition === 1
      ) {
        dot.classList.add(
          'lm-dot-far-prev'
        );
      } else if (
        visualPosition === 2
      ) {
        dot.classList.add(
          'lm-dot-prev'
        );
      } else if (
        visualPosition === 3
      ) {
        dot.classList.add(
          'lm-dot-active',
          'is-active'
        );
      } else if (
        visualPosition === 4
      ) {
        dot.classList.add(
          'lm-dot-next'
        );
      } else if (
        visualPosition === 5
      ) {
        dot.classList.add(
          'lm-dot-far-next'
        );
      } else {
        dot.classList.add(
          'lm-dot-hidden-next'
        );
      }
    }

    updatePagination() {
      if (
        !this.paginationTrack ||
        this.paginationDots.length === 0
      ) {
        return;
      }

      if (this.slides.length <= 5) {
        this.paginationDots.forEach(
          (dot, index) => {
            const isActive =
              index === this.logicalIndex;

            dot.dataset.slideTarget =
              String(index);

            dot.classList.toggle(
              'is-active',
              isActive
            );

            dot.setAttribute(
              'aria-current',
              isActive ? 'true' : 'false'
            );

            dot.setAttribute(
              'aria-label',
              `Medium ${index + 1} anzeigen`
            );
          }
        );

        return;
      }

      const currentDots =
        Array.from(
          this.paginationTrack.children
        );

      currentDots.forEach(
        (dot, visualPosition) => {
          const relativePosition =
            visualPosition - 3;

          const representedIndex =
            this.modulo(
              this.logicalIndex +
                relativePosition,
              this.slides.length
            );

          dot.dataset.slideTarget =
            String(representedIndex);

          dot.setAttribute(
            'aria-label',
            `Medium ${
              representedIndex + 1
            } anzeigen`
          );

          dot.setAttribute(
            'aria-current',
            relativePosition === 0
              ? 'true'
              : 'false'
          );

          this.applyPaginationDotClass(
            dot,
            visualPosition
          );
        }
      );
    }

    getPaginationMovement() {
      if (
        !this.paginationTrack ||
        this.paginationDots.length === 0
      ) {
        return 0;
      }

      const firstDot =
        this.paginationDots[0];

      const dotStyles =
        window.getComputedStyle(firstDot);

      const trackStyles =
        window.getComputedStyle(
          this.paginationTrack
        );

      const dotWidth =
        parseFloat(dotStyles.width) || 0;

      const gap =
        parseFloat(
          trackStyles.columnGap ||
            trackStyles.gap ||
            '0'
        ) || 0;

      return dotWidth + gap;
    }

    startPaginationAnimation(direction) {
      if (
        this.slides.length <= 5 ||
        !this.paginationTrack ||
        this.paginationDots.length !== 7 ||
        direction === 0
      ) {
        return;
      }

      if (this.paginationTimeout) {
        window.clearTimeout(
          this.paginationTimeout
        );

        this.paginationTimeout = null;
      }

      const movement =
        this.getPaginationMovement();

      if (movement <= 0) {
        return;
      }

      const currentDots =
        Array.from(
          this.paginationTrack.children
        );

      currentDots.forEach(
        (dot, index) => {
          this.applyPaginationDotClass(
            dot,
            index - direction
          );
        }
      );

      this.paginationTrack.style.transition =
        `transform ${ANIMATION_DURATION}ms ease`;

      if (direction > 0) {
        this.paginationTrack.style.transform =
          `translate3d(calc(-50% - ${movement}px), -50%, 0)`;
      } else {
        this.paginationTrack.style.transform =
          `translate3d(calc(-50% + ${movement}px), -50%, 0)`;
      }
    }

    finishPaginationAnimation(direction) {
      if (
        this.slides.length <= 5 ||
        !this.paginationTrack ||
        this.paginationDots.length !== 7 ||
        direction === 0
      ) {
        this.updatePagination();
        return;
      }

      this.paginationTrack.style.transition =
        'none';

      if (direction > 0) {
        const firstDot =
          this.paginationTrack
            .firstElementChild;

        if (firstDot) {
          this.paginationTrack.appendChild(
            firstDot
          );
        }
      } else {
        const lastDot =
          this.paginationTrack
            .lastElementChild;

        if (lastDot) {
          this.paginationTrack.insertBefore(
            lastDot,
            this.paginationTrack
              .firstElementChild
          );
        }
      }

      this.paginationTrack.style.transform =
        'translate3d(-50%, -50%, 0)';

      void this.paginationTrack.offsetWidth;

      this.updatePagination();
    }

    modulo(value, divisor) {
      return (
        ((value % divisor) + divisor) %
        divisor
      );
    }
  }

  function initializeGallery(gallery) {
    if (
      !gallery ||
      gallery.dataset
        .lmQuickAddGalleryInitialized ===
        'true'
    ) {
      return;
    }

    const track =
      gallery.querySelector(
        '.product__media-list'
      );

    const slides = track
      ? track.querySelectorAll(
          ':scope > .product__media-item'
        )
      : [];

    if (!track || slides.length === 0) {
      return;
    }

    gallery.dataset
      .lmQuickAddGalleryInitialized =
      'true';

    new LilMiracleQuickAddGallery(
      gallery
    );
  }

  function initializeAll(scope = document) {
    if (
      scope instanceof HTMLElement &&
      scope.matches(GALLERY_SELECTOR)
    ) {
      initializeGallery(scope);
    }

    scope
      .querySelectorAll?.(
        GALLERY_SELECTOR
      )
      .forEach(initializeGallery);
  }

  function start() {
    initializeAll(document);
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      {
        once: true
      }
    );
  } else {
    start();
  }

  /*
   * Quick Add wird dynamisch per fetch geladen.
   * Der Observer erkennt neu eingefügte Galerien.
   */
  const observer =
    new MutationObserver(
      (mutations) => {
        mutations.forEach(
          (mutation) => {
            mutation.addedNodes.forEach(
              (node) => {
                if (
                  !(
                    node instanceof
                    HTMLElement
                  )
                ) {
                  return;
                }

                initializeAll(node);
              }
            );
          }
        );
      }
    );

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeAll(event.target);
    }
  );
})();